import { Observable, of } from 'rxjs';
import { EnvironmentService } from '@core/services/environment.service';

export function getDataWithMockFallback<T>(
  mockData: T,
  realCall$: Observable<T>,
  environmentService: EnvironmentService
): Observable<T> {
  return environmentService.isProduction ? realCall$ : of(mockData);
}
